export const imageConnectionFragment = `
edges {
  node {
    title
    url(transform: {format: WEBP})
  }
}`

export const allPostsFragment = `
items {
  title
  url
  short_title
  category
  free_content
  thumbnailConnection {
    ${imageConnectionFragment}
  }
  description
}`

export const fragmentQL = (objName: string) => {
    return `
  ${objName} {
    canonical_url
    meta_description
    meta_title
    no_index
    open_graph_tags {
      og_description
      og_imageConnection{
        ${imageConnectionFragment}
      }
      og_type
      og_title
      og_site_name
      og_locale
    }
  }`
}

export const seoFragment = fragmentQL('seo')

export const providerSeoFragment = fragmentQL('provider_seo')

export const textBlockFragment = `
text_block {
  text
  title
}`

export const calloutBlockFragment = `
__typename
callout {
  button_click_id

  button {
    href
    title
  }
  secondary_button {
    href
    title
  }
  description
  tagline
  text_alignment
  title
  type
  enable_location_search
  background_color
  badge {
    iconConnection {
      ${imageConnectionFragment}
    }
    text
  }
}`

export const pointerBlockFragment = `
__typename
pointers_block {
  title
  type
  background_color
  description
  image_alignment
  class_name
  custom_styling
  click_id
  imageConnection {
   ${imageConnectionFragment}
  }
  mobile_imageConnection{
    ${imageConnectionFragment}
  }
  footnote
  link {
    href
    title
  }
  pointers {
    bullets {
      description
      title
    }
    description
    iconConnection {
      ${imageConnectionFragment}
    }
    link {
      href
      title
    }
    external_link
    sub_title
    title
  }
  
}`

export const imageGridFragment = `
__typename
image_grid {
  title
  type
  description
  custom_styling
  imagesConnection {
    ${imageConnectionFragment}
  }
  image_urls{
    url
    click_id
    imageConnection{
      ${imageConnectionFragment}
    }
  }        
}`

export const textFragment = `
__typename
text {
  title
  type
  description
  background_color
  custom_styling
  text_block {
    description
    title
  }      
}`
export const quoteFragment = `
__typename
quote {
  author
  quote_description
  title
  about_author {
    address
    designation
    name
  }
  avatar_imageConnection {
    edges {
      node {
        url
      }
    }
  }
}`
export const carouselBlockFragment = `
__typename
carousel {
  description
  title
  type
  background_color
  left_arrow_click_id
  right_arrow_click_id
  slides {
    title
    title_description
    description
    sub_title
    carousel_index_ref
    font_color
    background_color
    footnote
    is_footnote_below_cta_in_mobile_view
    imagegrid {
      description
      title
      image_urls {
        click_id
        url
        imageConnection {
          edges {
            node {
              url
            }
          }
        }
      }
    }
    imageConnection {
      ${imageConnectionFragment}
    }
    mobile_imageConnection {
      ${imageConnectionFragment}
    }
    banner_logoConnection {
      ${imageConnectionFragment}
    }
    title_imageConnection {
      ${imageConnectionFragment}
    }
    click_id,
    link {
      href
      title
    }
    link_multi {
    href
    title
    }
    pointers {
      bullets {
        title
      }
      description
      sub_head
      title
    }
    custom_styling
  }        
}`
export const codeBlockFragment = `
__typename
code_block {
  title
  sub_title
  description
  tagline
  code
  description
  mobile_background_color
  sub_title
  title
  type
  mobile_background_color
}`

export const contentGridFragment = `
__typename
content_grid {
  title
  type
  description
  link {
    href
    title
  }
  custom_styling
  footer
  click_id
  content {
    title
    sub_head
    external_link
    description
    link {
      href
      title
    }
    imageConnection {
      ${imageConnectionFragment}
    }
    mobile_imageConnection{
      ${imageConnectionFragment}
    }
  }       
}`

export const splitImageBlockFragment = `
__typename
split_image_block {
  link_click_id
  head_title
  title
  mobile_title
  mobile_background_color
  sub_title
  sub_head
  image_alignment
  description
  background_color
  type
  link {
    href
    title
  }
  type
  imageConnection {
    ${imageConnectionFragment}
  }
  iconConnection {
    ${imageConnectionFragment}
  }          
  mobile_imageConnection {
    ${imageConnectionFragment}
  }          
}`

export const treatmentResultBlock = `
__typename
treatment_results {
  title
  sub_head
  description
  background_color
  image_group {
    after_imageConnection {
     ${imageConnectionFragment}
    }
    before_imageConnection{
      ${imageConnectionFragment}
    }
    title
  }         
}`

export const splitTextBlockFragment = `
__typename
split_text_block {
  left {
    title
    sub_title
    sub_head
    description
    background_color
  }
  right {
    title
    sub_title
    sub_head
    description
    background_color
  }
}`
export const testimonialFragment = `
title
sub_title
author
description
imageConnection {
  edges {
    node {
      url
    }
  }
}
background_imageConnection {
  edges {
    node {
      url
    }
  }
}`
export const promoBannerFragement = `promo_banner {
  background_color
  only_on_mobile
  border_hidden
  text_color
  title
  click_id
  iconConnection {
    edges {
      node {
        url
      }
    }
  }
  link {
    title
    href
  }
 link_multi {
    title
    href
  }
}`
